// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckBox_root__2_Vo1","rounded":"CheckBox_rounded__GC0XO"};